/*
1.在使用 WKWebView 加载带有跨域 iframe 的页面时，会遇到一个让开发者头疼的问题：当 WKWebView 关闭时，iframe 加载的跨域页面会被清除 localStorage。
这种行为会导致一些数据无法持久化保存，从而影响用户体验，特别是在依赖 localStorage 保存状态或数据的 Web 应用中。
2.单独使用localStorage存储的时候，项目被内嵌在iframe时，当用户在后台放置（挂起）一段时间后，再次切回来获取localStorage内容，都是null了
*/

import { log } from "@/components/utils/HComFunctions.js";

export const SaveEnum = {
    savePwd: 'saveEnum_savePwd',
    userAccount: 'saveEnum_userAccount',
    userPwd: 'saveEnum_userPwd',
    userId: 'saveEnum_userId',
    userToken: 'saveEnum_userToken',
    userDid: 'saveEnum_userDid',
    lobbySearchHistoryList: 'saveEnum_lobbySearchHistoryList',
};

class HSp {
    static instance;

    constructor() {
        if (HSp.instance) {
            return HSp.instance;
        }
        HSp.instance = this;
    }

    utf8ToBase64(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) =>
            String.fromCharCode(parseInt(p1, 16))
        ));
    }

    base64ToUtf8(base64Str) {
        return decodeURIComponent(atob(base64Str).split('').map(c =>
            '%' + c.charCodeAt(0).toString(16).padStart(2, '0')
        ).join(''));
    }

    processEncode(originStr) {
        const base64Text = this.utf8ToBase64(originStr);
        const reversedText = base64Text.split('').reverse().join('');
        const length = reversedText.length;
        const mid = Math.floor(length / 2);
        const randomChars = Array.from({ length: 4 }, () =>
            String.fromCharCode(Math.floor(Math.random() * 26) + 97)
        );

        let encryptedText =
            reversedText.substring(0, mid) +
            randomChars.join('') +
            reversedText.substring(mid);

        encryptedText = encryptedText.substring(2) + encryptedText.substring(0, 2);
        return encryptedText;
    }

    processDecode(encodeStr) {
        encodeStr = encodeStr.slice(-2) + encodeStr.slice(0, -2);

        const mid = (encodeStr.length - 4) / 2;
        const plainText =
            encodeStr.slice(0, mid) + encodeStr.slice(mid + 4);

        const base64Str = plainText.split('').reverse().join('');
        return this.base64ToUtf8(base64Str);
    }

    setString(key, value) {
        try {
            localStorage.setItem(`mg_${key}`, this.processEncode(value));
            return true;
        } catch (e) {
            log('Error saving string to localStorage:' + e.stack);
            return false;
        }
    }

    getString(key) {
        const result = localStorage.getItem(`mg_${key}`);
        if (result) {
            return this.processDecode(result);
        }
        return null;
    }

    setStringList(key, value) {
        try {
            const encodedList = value.map(item => this.processEncode(item));
            localStorage.setItem(`mg_${key}`, JSON.stringify(encodedList));
            return true;
        } catch (e) {
            log('Error saving string list to localStorage:' + e.stack);
            return false;
        }
    }

    getStringList(key) {
        const list = localStorage.getItem(`mg_${key}`);
        if (list) {
            try {
                return JSON.parse(list).map(item => this.processDecode(item));
            } catch (e) {
                log('Error parsing string list from localStorage:' + e.stack);
                return null;
            }
        }
        return null;
    }

    setMap(key, value) {
        return this.setString(key, JSON.stringify(value));
    }

    getMap(key) {
        const mapStr = this.getString(key);
        if (mapStr) {
            try {
                return JSON.parse(mapStr);
            } catch (e) {
                log('Error parsing map from localStorage:' + e.stack);
                return null;
            }
        }
        return null;
    }

    setBool(key, value) {
        return this.setString(key, value === true ? '1' : '0');
    }

    getBool(key) {
        const result = this.getString(key);
        return result === '1';
    }

    setInt(key, value) {
        return this.setString(key, value.toString());
    }

    getInt(key) {
        const result = this.getString(key);
        return result ? parseInt(result, 10) : null;
    }

    setDouble(key, value) {
        return this.setString(key, value.toString());
    }

    getDouble(key) {
        const result = this.getString(key);
        return result ? parseFloat(result) : null;
    }

    remove(key) {
        try {
            localStorage.removeItem(`mg_${key}`);
            return true;
        } catch (e) {
            log('Error removing item from localStorage:' + e.stack);
            return false;
        }
    }

    checkKey(key){
        return localStorage.getItem(`mg_${key}`) !== null;
    }

    clear() {
        try {
            localStorage.clear();
            return true;
        } catch (e) {
            log('Error clearing localStorage:' + e.stack);
            return false;
        }
    }
}

// 导出单例
export const hsp = new HSp();
